import { Container, Label, Value } from './DescriptionItemStyles';
import { Skeleton } from '@/components/ui/skeleton';
import { cn } from '@/lib/utils';

interface DescriptionItemProps {
  label: string;
  value: string;
  link?: string;
}

const DescriptionItem = ({ label, value, link }: DescriptionItemProps) => {
  return (
    <Container>
      <Label>
        <div className="text-text-400 text-sm">{label}</div>
      </Label>
      <Value onClick={link ? () => window.open(link, '_blank') : () => {}} hasLink={link}>
        {value ? (
          <div className={cn('text-sm', link ? 'text-legacy-blue-200' : 'text-text-300')}>
            {value}
          </div>
        ) : (
          <Skeleton className="w-[240px] h-[12px]" />
        )}
      </Value>
    </Container>
  );
};

export default DescriptionItem;
